import React, { useState, useEffect } from "react";
import { Row, Col, Container, Spinner } from "react-bootstrap/";
import { connect } from "react-redux";
import { resourceService } from "../../services/resourceService";

const Footer = ({ isAuthenticated }) => {
  const [legalResources, setLegalResources] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLegal = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }
      try {
        const data = await resourceService.getResources('legal');
        setLegalResources(data);
      } catch (error) {
        console.error("Error loading legal resources for footer:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLegal();
  }, [isAuthenticated]);

  if (!isAuthenticated) return null;

  if (loading && legalResources.length === 0) {
    return (
      <Container fluid className="py-2 border-top bg-white">
        <Spinner animation="border" size="sm" variant="secondary" className="d-block mx-auto" />
      </Container>
    );
  }

  if (legalResources.length === 0) return null;

  return (
    <Container fluid className="py-3 mt-auto border-top bg-white">
      <Row className="align-items-center justify-content-center text-center">
        {legalResources.map((resource, index) => (
          <React.Fragment key={resource.id}>
            <Col md="auto" className="px-3">
              <a
                href={resource.file_url}
                target="_blank"
                rel="noopener noreferrer"
                className="text-secondary small text-decoration-none hover-primary"
              >
                {resource.title}
              </a>
            </Col>
            {index < legalResources.length - 1 && (
              <Col md="auto" className="px-0 d-none d-md-block">
                <span className="text-muted small">|</span>
              </Col>
            )}
          </React.Fragment>
        ))}
      </Row>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps)(Footer);
